const sectionProductsList = document.querySelector('.products-list');

/* SWIPER */

let productsListSwiper = new Swiper(".products-list .swiper", {
  pagination: {
    el: ".products-list .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".products-list .swiper-button-next",
    prevEl: ".products-list .swiper-button-prev",
  },
  loop: false,
  centeredSlides: false,
  slidesPerView: 2,
  spaceBetween: 20,
  autoHeight: false,
  breakpoints: {
    749: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    }
    }
});
  
if (typeof apparitionFromRight === 'undefined') {
  
  const apparitionFromRight = document.querySelectorAll('.apparition-from-right');
  
  const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
          if (entry.isIntersecting) {
              entry.target.classList.add('animate');
          }
      });
  }, {
      threshold: 0.1,
  });
  
  apparitionFromRight.forEach((el) => observer.observe(el));
    
}

/* TAB TRANSITION */

sectionProductsList.querySelectorAll('.products-list__tabs .tab__item').forEach(tab => {

  tab.addEventListener('click', () => {

    sectionProductsList.querySelectorAll('.products-list__tabs .tab__item').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    sectionProductsList.querySelectorAll('.products-list__contents .contents__item').forEach(content => {
      content.classList.remove('active');
      content.style.display = 'none';
    });

    const sectionProductsListContents = sectionProductsList.querySelectorAll('.products-list__contents .contents__item');
    const newContent = Array.from(sectionProductsListContents).find(content => content.id === tab.id);

    if (newContent) {
      newContent.style.display = 'block';

      setTimeout(() => {
        newContent.classList.add('active');
      }, 10);
      
    }
    
  });

});

/* PRODUCTS HREF */

const sectionProductsListProductsItem = sectionProductsList.querySelectorAll('.products-list__contents .product__item');

sectionProductsListProductsItem.forEach(product => {
  product.addEventListener('click', () => {
    const productPageUrl = product.getAttribute('href');
    window.location.href = productPageUrl;
  })
})

/* SWIPER IMAGES*/

let productsImageSwiper= new Swiper(".products-list .item__image.swiper-images", {
  scrollbar: {
    el: ".products-list .item__image .swiper-scrollbar",
    hide: false,
    draggable: true, 
  },
  loop: false,
  slidesPerView:1,
  autoHeight: false,
  breakpoints: {
      749: {
        slidesPerView: 1,
        spaceBetween: 20,
      }
    }
});